import React from 'react';

type OptionType = { [string: string]: any };
type OptionsType = Array<OptionType>;

interface Options {
  id: string;
  options: OptionsType;
  className?: string;
  contactFormRole?: string;
  disabled?: boolean;
  onChange: (data: any) => void;
  selectedIndex: (data: any) => void;
}

const FormDropdown = ({ options, onChange, selectedIndex, className, contactFormRole, disabled, id }: Options) => {
  const onSelectChange = (e: any) => {
    onChange(e.target.value);
    selectedIndex(e.target.selectedIndex);
  };

  return (
    <div className="main-text-field dropdown-input">
      <select
        id={id}
        className={`main-text-field-input select-input ${className}`}
        contact-form-role={contactFormRole}
        disabled={disabled}
        onChange={onSelectChange}
      >
        {options.map((item: any) => (
          <option key={item.listElement} value={item.listElement}>
            {item.listElement}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FormDropdown;
